// extracted by mini-css-extract-plugin
export default {"round":"round--ZNW2k","klarna":"klarna--MZhYe","facebook":"facebook--2+hNL"};